import React from "react";
import { TextField, MenuItem, useTheme } from "@mui/material";
import { useField, useFormikContext } from "formik";

/**
 * options: Array of objects { value: any, label: string }
 */
const FormSelectField = ({ name, label, options = [], ...props }) => {
  const theme = useTheme();
  const [field, meta] = useField(name);
  const { setFieldValue } = useFormikContext();

  const handleChange = (evt) => {
    setFieldValue(name, evt.target.value);
    if (props.onChange) props.onChange(evt); // Allow custom side effects
  };

  return (
    <TextField
      {...field}
      {...props}
      select
      fullWidth
      label={label}
      variant="outlined"
      margin="dense"
      onChange={handleChange}
      error={meta.touched && Boolean(meta.error)}
      helperText={meta.touched && meta.error}
      InputProps={{
        sx: { borderRadius: theme.appRadius.sm },
      }}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default FormSelectField;
